<!--
 * @Description: 
 * @Author:  
 * @Date: 2023-09-11 16:28:49
 * @LastEditTime: 2024-05-15 14:05:31
 * @LastEditors:  
-->
<template lang="html">
  <div class="container">
    <div class="img-group">
      <img :src="$store.state.static_img_url + 'pic/pc3.5/404_h5.png'">
      <div class="desc-p">
        <p>非常抱歉~</p>
        <p>当前页面暂不支持手机浏览器打开<br/>请访问电脑端网站查看</p>
      </div>
    </div>
    <!-- <button @click="goApp">下载APP</button> -->
  </div>
</template>

<script>
export default {
  methods: {
    goApp() {
      if(this.isiOS) {
        window.location.href = 'https://app.vbdata.cn/dongmai/'
      } else {
        let href = this.$store.state.index2_path + '/mobile/downloadApp'
        window.location.href = href
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.container
  display: flex
  flex-direction: column
  align-items: center
  padding  0 .32rem
  position: relative;
  top 34.9753vh
  .img-group
    position: relative
    padding 0 .1rem
    .desc-p
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      text-align: center
      font-size: .28rem
      color: #333333;
      line-height: .52rem
      text-align: center;
      span
        color #FA5A00
  button
    display: block
    background: #FA5A00
    width: 100%
    height: .94rem
    border-radius:.47rem
    color: #FFFFFF
    font-size: .32rem
    border: none
    position: relative
    top 6.94rem
</style>
